import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDate, asDateTime, asLabel, createdByField, field, lastModifiedByField, type Row, text } from './kit';

const def = OBJECT_DEFS.guides;

/** Long text with its line breaks kept: the body is markdown. */
const asLines = (value: unknown) =>
  typeof value === 'string' && value.trim() !== '' ? <div className="whitespace-pre-wrap">{value}</div> : text(value);

/** One long-form guide (0118). Rationale: guides.md. */
export const guides: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Guide',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('name', 'Name'),
    field('code', 'Code', { help: 'What readers ask for, e.g. outreach-voice.' }),
    field('domain', 'Domain', { help: 'What it belongs to, e.g. outreach. Readers load a domain’s live guides.' }),
    field('status', 'Status', { format: asLabel, help: 'Draft guides are not read by agents; live ones are.' }),
    field('version', 'Version', { format: asDate, help: 'Set to today when the body changes, unless you set it in the same edit.' }),
    field('sort_order', 'Sort Order'),
    field('description', 'Description', { wide: true }),
    field('body', 'Body', { wide: true, format: asLines, help: 'Markdown, the whole guide. Earlier versions are in its history.' }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['name', 'code', 'domain', 'status', 'version', 'sort_order', 'description'] },
    { key: 'body', label: 'Body', fields: ['body'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'code', 'domain'],
};
